export default __webpack_public_path__ + "i18n/translation-ja.fd12231d.json";